module.exports = __webpack_public_path__ + "img/blank-gray-icon.35beaf98.svg";